module.exports = __webpack_public_path__ + "static/media/bg-r-600.19b9289d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Selection/assets/bg-r-600.png
// module id = 193
// module chunks = 0